<template>
<div class="chapter">
<div class="inner_page">
<h2 class="PT">ED</h2>
<p class="PIT">Girls I have liked:</p>
<p class="PTX">Jenn Challener</p>
<p class="PTX">Aimee Eastwood</p>
<p class="PTX">Raina Korman</p>
<p class="PTX">Ms. Reidy</p>
<p class="PTX">Jennifer Love Hewitt (Okay, I was fourteen)</p>
<p class="PTX">Storm, Rogue, Jubilee, Jean Grey</p>
<p class="PTXb">The lady behind the counter at Balducci’s</p>
<p class="PIT">Girls I have loved:</p>
<p class="PTX">Heather Gannis</p>
<p class="PTXb">Gaia Moore</p>
<p class="PIT">Girls who have ripped out my cardiovascular muscle and squashed it under their feet:</p>
<p class="PTX">Heather Gannis</p>
<p class="PTXb">Gaia Moore</p>
<p class="PTX">Anyone besides me sensing a pattern around here?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part3.vue?bdd3d1b2